export type Shirt = 'S' | 'M' | 'L' | 'XL';
export type Diet = 'omnivora' | 'vegetariana' | 'vegana';
export type HackerRole = 'desarrollo' | 'producto' | 'diseno' | 'ventas' | 'qa';

export interface ProfileFormData {
  country: string;
  linkedin: string;
  x: string;
  bio: string;
  education: string;
  roles: HackerRole[];
  isVeteran: boolean | null;
  previousHackathons: string;
  shirtSize: Shirt | '';
  diet: Diet | '';
  allergies: string;
  physicalIssues: string;
  shareInfoWithSponsors: boolean;
  // The profile-photo step (editions with ApplyProfilePhoto): the chosen photo's signed
  // blob id and our URL for it, or the decision to skip.
  photoSignedId: string | null;
  photoUrl: string | null;
  photoSkipped: boolean;
}

export const PROFILE_STEPS = [
  'personal',
  'photo',
  'builder',
  'education',
  'role',
  'veteran',
  'considerations',
] as const;

export type ProfileStep = (typeof PROFILE_STEPS)[number];

// The steps an edition's wizard runs: the photo step only where the server offers it.
export function profileSteps(withPhoto: boolean): readonly ProfileStep[] {
  return withPhoto
    ? PROFILE_STEPS
    : PROFILE_STEPS.filter((step) => step !== 'photo');
}

export const STEP_LABELS: Record<ProfileStep, string> = {
  personal: 'Personal',
  photo: 'Foto',
  builder: 'Builder',
  education: 'Education',
  role: 'Role',
  veteran: 'Veteran',
  considerations: 'Considerations',
};
